import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/global-error.jsx")